<template>
  <div id="contents">
    <div class="recruit_rorando" >
      <div class="recruit_rorando_main">
        <div class="title_area">
          <p class="title">俺とテレビ朝日映像</p>
        </div>
        <div @click="close" class="close_icon">
          <img src="../assets/img/common/recruit_2021/close_icon.svg" />
        </div>
        <p class="caption">
          2018年、「ソノサキ」の取材で出会ったことから始まった、ローランドさんとテレビ朝日映像のお付き合い。<br />
          現在は、当社の「TAPキャスト」がマネジメントを行っています。そんなローランドさんに、質問！
        </p>
        <div class="main_image">
          <img src="../assets/img/common/recruit_2021/rorando/main.png" />
        </div>
        <div class="impression">
          <div class="text_area">
            <h3>Ｑ.テレビ朝日映像の印象は？</h3>
            <p>　単刀直入に言うと、「見る目あるな」。ローランドを発掘したのって、テレビ朝日映像じゃないですか。先見の明があるってこと。俺の中では評価高いっすよ。</p>
          </div>
          <div class="image_area">
            <img src="../assets/img/common/recruit_2021/rorando/impression.png" />
          </div>
        </div>
        <div class="memories">
          <div class="text_area">
            <h3>Ｑ.一番印象的な思い出や出来事は？</h3>
            <p>　ロケも収録もたくさんしましたね。寒暖差が激しい東京ーモンゴルのロケ帰り、トランジットのミスでスタッフたちと硬いベンチで一晩明かしたことも。飛行機も普段はビジネス以下は乗らないのに、この時はLCC。座席の角度は80度ぐらいだった気がする（笑）。一番印象に残ってるのは、「ソノサキ」最終回でスタジオにサプライズ出演した時。足音を立てないように俺の靴の裏にフェルトを貼ったんだけど、まさか27歳にもなって靴裏にフェルトとは…。番組の演出を一番に考えてこんなことをするのもテレビ朝日映像のスタッフならではって感じ。</p>
          </div>
        </div>
        <div class="difference">
          <div class="text_area">
            <h3>Ｑ.他社（がつくった番組）</h3>
            <h3>との違いは？ </h3>
            <p>　リアル感が違いますよね。バラエティってもっと面白くつくるのかなと思ってたんだけど、密着取材ではガチの姿を撮られてた。人を怒る時も、カメラが回ってればカメラを意識すると思うんだけど、密着取材ではそんなことなくて、真剣に何かを伝えている姿や本当に憤ってる姿がそのまま撮られてた。スタッフは空気になるぐらい、その場に自然に溶け込んでたと思う。</p>
          </div>
          <div class="image_area">
            <img src="../assets/img/common/recruit_2021/rorando/difference.png" />
          </div>
        </div>
        <div class="message">
          <div class="text_area">
            <h3>Ｑ.テレビ朝日映像にメッセージを！</h3>
            <p>俺は勝負の世界に生きてきて、「勝とう」と思って勝ったことは一度もない。「No.1になろう」と思ってなったわけじゃない。まず、お客さまを楽しませることを第一に考えて、気がついたらNo.1になってた。テレビも同じじゃないですか？視聴者や作り手自身が面白いと思うものをつくっていけばいいと思います。まだまだ伸びしろもセンスもあるし、期待してますよ。辛くなったら、うちの店（THE CLUB）においで。テレビ朝日映像って言ってくれればサービスしますよ、料金は２割増しだけど（笑）。</p>
          </div>
        </div>
        <div class="profile">
          <div class="image_area">
            <img src="../assets/img/common/recruit_2021/rorando/profile.png" />
          </div>
          <div class="text_area">
            <h3>ローランド</h3>
            <img src="../assets/img/common/recruit_2021/rorando/pink_line.png" />
            <p>1992年、東京都生まれ。高校卒業後すぐに大学を中退し、18歳でホストデビュー。1年間の下積みを経て、歌舞伎町の数々の最年少記録を更新し、「現代ホスト界の帝王」と称される。現在はホストクラブ経営の他に、タレントや実業家、投資家など多方面で活躍中。</p>
          </div>
        </div>

      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_rorando',
  data() {
    return {
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'post_type'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_rorando
    &_main
      width: 1000px
      margin: 161px auto 150px
      padding-bottom: 75px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -49px
        left: 55px
      .title
        @include recruit_font(41px, 64px, .176em)
        color: #02ACC3
        background: #FFF500
        padding: 5px 19px 9px 18px
        display: table

      .close_icon
        position: absolute
        right: 0px
        top: -65px
        img
          width: 40px
          height: 40px
      .caption
        @include recruit_font(14px, 28px, 3px)
        display: inline-block
        margin: 72px 55px 37px
        width: 890px
      .main_image
        width: 658px
        height: 414px
        margin: 0 auto 87px
        img
          width: 100%
      .impression
        display: flex
        justify-content: space-between
        width: 865px
        margin: 0 auto 73px
        .text_area
          width: 463px
          h3
            @include recruit_font(25px, 39px, .126em)
            display: inline-block
            color: #02ACC3
            background-color: #FFF500
            margin: 60px 0 21px
            padding: 0 4px
          p
            @include recruit_font(12px, 24px, .082em)
        .image_area
          width: 364px
          height: 242px
          img
            width: 100%
      .memories
        width: 865px
        margin: 0 auto 63px
        .text_area
          h3
            @include recruit_font(25px, 39px, .126em)
            display: inline-block
            color: #02ACC3
            background-color: #FFF500
            margin-bottom: 21px
            padding: 0 4px
          p
            @include recruit_font(12px, 24px, .072em)
            height: 109px
      .difference
        width: 865px
        margin: 0 auto 84px
        display: flex
        justify-content: space-between
        .text_area
          width: 450px
          h3
            @include recruit_font(25px, 36px, .126em)
            display: inline-block
            color: #02ACC3
            background-color: #FFF500
            &:first-child
              margin: 5px 0 0px
              padding: 0 0 0 4px
            &:not(:first-child)
              margin: 0px 0 26px
              padding: 0 4px 0 4px
          p
            @include recruit_font(12px, 24px, .072em)
        .image_area
          width: 369px
          height: 229px
          img
            width: 100%
      .message
        width: 865px
        margin: 0 auto 76px
        .text_area
          width: 100%
          h3
            @include recruit_font(25px, 39px, .126em)
            display: inline-block
            color: #02ACC3
            background-color: #FFF500
            margin-bottom: 21px
            padding: 0 4px
          p
            @include recruit_font(12px, 24px, .072em)
            height: 108px
      .profile
        display: flex
        justify-content: space-between
        width: 865px
        margin: 0 auto
        .image_area
          margin-right: 40px
          img
            width: 140px
            height: 140px
        .text_area
          h3
            @include recruit_font(22px, 22px, .206em)
            display: inline-block
            margin: 9px 0 19px
            color: #FF7689
          img
            width: 100%
            height: 3px
            margin-bottom: 13px
            display: block
          p
            @include recruit_font(12px, 23px, .206em)
</style>



// WEBPACK FOOTER //
// src/components/recruit_rorando.vue